import * as Long from "long";
import * as React from "react";
import { isFontOutlines } from "../../../constants/IdFontWithOutlines";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { utilLoca } from "../../../utils/i18n/utilLoca";
import { warn } from "../../../utils/logging/logging";
import { utilNumber } from "../../../utils/utilNumber";
import { ContextLoca } from "../../loca/ContextLoca";
import { FontWithOutline } from "../font-with-outline/FontWithOutline";
import { TypeNumberFormat } from "./TypeNumberFormat";
var percentageFormat = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 1,
    useGrouping: true,
});
var formatNone = function (amount) { return utilNumber.format(amount); };
var formatAdd = function (amount) {
    var locaReplacements = new Map([[ReplacementLoca.zero_0, utilNumber.format(amount)]]);
    if (amount.lessThan(0)) {
        return utilNumber.format(amount);
    }
    else if (amount.equals(0)) {
        return "0";
    }
    return utilLoca.get(IdLoca.value_nominal_add, locaReplacements);
};
var formatAddExceptZero = function (amount) {
    var locaReplacements = new Map([[ReplacementLoca.zero_0, utilNumber.format(amount)]]);
    if (amount.lessThan(0)) {
        return utilNumber.format(amount);
    }
    else if (amount.equals(0)) {
        return "";
    }
    return utilLoca.get(IdLoca.value_nominal_add, locaReplacements);
};
var formatAddIncludingZero = function (amount) {
    var locaReplacements = new Map([[ReplacementLoca.zero_0, utilNumber.format(amount)]]);
    if (amount.lessThan(0)) {
        return utilNumber.format(amount);
    }
    return utilLoca.get(IdLoca.value_nominal_add, locaReplacements);
};
var formatSubtract = function (amount) {
    var locaReplacements = new Map([[ReplacementLoca.zero_0, utilNumber.format(amount)]]);
    if (amount.lessThan(0)) {
        return utilNumber.format(amount);
    }
    else if (amount.equals(0)) {
        return "0";
    }
    return utilLoca.get(IdLoca.value_nominal_subtract, locaReplacements);
};
var formatUnsigned = function (amount) {
    if (amount.equals(0)) {
        return "0";
    }
    return "" + Math.abs(amount.toNumber());
};
var formatPercentageSigned = function (amount) {
    if (amount.lessThan(0)) {
        var locaReplacementsSubtract = new Map([
            [ReplacementLoca.zero_0, formatUnsigned(amount)],
        ]);
        return utilLoca.get(IdLoca.value_percentage_subtract, locaReplacementsSubtract);
    }
    else if (amount.equals(0)) {
        return "0";
    }
    var locaReplacementsAdd = new Map([[ReplacementLoca.zero_0, utilNumber.format(amount)]]);
    return utilLoca.get(IdLoca.value_percentage_add, locaReplacementsAdd);
};
var formatPercentage = function (amount) {
    var replacements = new Map([[ReplacementLoca.zero_0, percentageFormat.format(amount)]]);
    return utilLoca.get(IdLoca.value_percentage, replacements);
};
var formatRoundPercentage = function (amount) {
    var replacements = new Map([[ReplacementLoca.zero_0, utilNumber.format(amount)]]);
    return utilLoca.get(IdLoca.value_percentage, replacements);
};
var formatMultiplication = function (amount) {
    var replacements = new Map([[ReplacementLoca.zero_0, utilNumber.format(amount)]]);
    if (amount <= 0) {
        return "";
    }
    return utilLoca.get(IdLoca.xTimes, replacements);
};
export var NumberFormat = function (_a) {
    var amount = _a.amount, _b = _a.format, format = _b === void 0 ? TypeNumberFormat.None : _b, className = _a.className;
    return (React.createElement(ContextLoca.Consumer, null, function () {
        var locaOptions = utilLoca.getOptions();
        if (locaOptions.convertToSymbols) {
            return "###";
        }
        var formatter = NumberFormatMap.get(format);
        var numberText = amount.toString();
        if (formatter != undefined) {
            var value = NumberFormats.has(format) ? amount : Long.fromValue(amount);
            numberText = formatter(value);
        }
        else {
            warn("NumberFormat: formatter not registered for format: " + TypeNumberFormat[format]);
        }
        if (isFontOutlines(className)) {
            return React.createElement(FontWithOutline, { style: className }, numberText);
        }
        return React.createElement("span", { className: className }, numberText);
    }));
};
var NumberFormats = new Set([TypeNumberFormat.Percent]);
export var NumberFormatMap = new Map([
    [TypeNumberFormat.None, formatNone],
    [TypeNumberFormat.Add, formatAdd],
    [TypeNumberFormat.AddExceptZero, formatAddExceptZero],
    [TypeNumberFormat.AddIncludingZero, formatAddIncludingZero],
    [TypeNumberFormat.Subtract, formatSubtract],
    [TypeNumberFormat.Unsigned, formatUnsigned],
    [TypeNumberFormat.SignedPercent, formatPercentageSigned],
    [TypeNumberFormat.Percent, formatPercentage],
    [TypeNumberFormat.RoundedPercent, formatRoundPercentage],
    [TypeNumberFormat.Multiplication, formatMultiplication],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/number-format/NumberFormat.tsx
// module id = 16
// module chunks = 3